import { formatDistanceToNow } from 'date-fns';
import { es } from 'date-fns/locale';
import { ArrowUp, Clock } from '@phosphor-icons/react';

import { Badge } from '@/components/ui';
import { UserAvatar } from '@/components/features/UserAvatar/UserAvatar';

import type { Poll } from '@/types/poll';

import styles from './PollMeta.module.css';

interface PollMetaProps {
    poll: Poll;
}

export function PollMeta({ poll }: PollMetaProps) {
    const timeAgo = formatDistanceToNow(new Date(poll.created), {
        addSuffix: true,
        locale: es,
    });

    return (
        <div className={styles.container}>
            <div className={styles.author}>
                <UserAvatar
                    src={poll.author.avatar_url}
                    name={poll.author.display_name}
                    size="md"
                />
                <div className={styles.authorInfo}>
                    <span className={styles.authorName}>{poll.author.display_name}</span>
                    <span className={styles.time}>
                        <Clock size={12} />
                        {timeAgo}
                    </span>
                </div>
            </div>
            <div className={styles.stats}>
                <Badge variant={poll.is_active ? 'success' : 'error'}>
                    {poll.is_active ? 'Activa' : 'Cerrada'}
                </Badge>
                <div className={styles.voteBadge}>
                    <ArrowUp size={12} weight="bold" />
                    <span>{poll.total_votes} votos</span>
                </div>
            </div>
        </div>
    );
}
